function hexToRgb(hex) {
	if (hex.startsWith('#')) {
		hex = hex.slice(1);
	}
	if (hex.length === 3) {
		hex = hex.split('').map(function (char) {
			return char + char;
		}).join('');
	}
	const r = parseInt(hex.slice(0, 2), 16);
	const g = parseInt(hex.slice(2, 4), 16);
	const b = parseInt(hex.slice(4, 6), 16);
	return { r, g, b };
}

function isLightDarkColor(color) {
	const { r, g, b } = hexToRgb(color);
	const brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b;
	return brightness;
}

function formValidate($this) {
	const $parent = $this.closest('.form-group');
	const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	if ($this.val() === '') {
		$parent.addClass('has-error');
	} else {
		if ($this.attr('type') === 'email') {
			if (!emailRegex.test($this.val())) {
				$parent.addClass('has-error');
			} else {
				$parent.removeClass('has-error');
			}
		} else {
			$parent.removeClass('has-error');
		}
	}
}

function initDaterangepicker($datepicker) {
	const initialValue = $datepicker.val();
	let initialStartDate = moment();
	let initialEndDate = moment();
	if (initialValue) {
		initialStartDate = moment(initialValue.split('-')[0], 'DD.MM.YY');
		initialEndDate = moment(initialValue.split('-')[1], 'DD.MM.YY');
	}
	$datepicker.daterangepicker({
		minDate: typeof daterangepickerMinDate !== 'undefined' ? moment(daterangepickerMinDate, 'DD.MM.YY') : undefined,
		maxDate: typeof daterangepickerMaxDate !== 'undefined' ? moment(daterangepickerMaxDate, 'DD.MM.YY') : moment(),
		startDate: initialStartDate,
		endDate: initialEndDate,
		autoUpdateInput: false,
		// linkedCalendars: false,
		// opens: 'left',
		alwaysShowCalendars: true,
		showCustomRangeLabel: false,
		ranges: {
			'Heute': [moment(), moment()],
			'Gestern': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
			'Letzte 7 Tage': [moment().subtract(6, 'days'), moment()],
			'Letzte 30 Tage': [moment().subtract(29, 'days'), moment()],
			'Letzte 90 Tage': [moment().subtract(89, 'days'), moment()],
			'Letzte 365 Tage': [moment().subtract(364, 'days'), moment()],
			'Letzter Monat': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
			'Letzte 12 Monate': [moment().subtract(12, 'month').add(1, 'day'), moment()],
			'Letztes Jahr': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
			'Woche bis Heute': [moment().subtract(1, 'week'), moment()],
			'Monat bis Heute': [moment().subtract(1, 'month'), moment()],
			'Quartal bis Heute': [moment().subtract(1, 'quarter'), moment()],
			'Year to date': [moment().subtract(1, 'year'), moment()],
			'Quarter 1': [moment().month(0).date(1).startOf('quarter'), moment().month(0).date(1).endOf('quarter')],
			'Quarter 2': [moment().month(3).date(1).startOf('quarter'), moment().month(3).date(1).endOf('quarter')],
			'Quarter 3': [moment().month(6).date(1).startOf('quarter'), moment().month(6).date(1).endOf('quarter')],
			'Quarter 4': [moment().month(9).date(1).startOf('quarter'), moment().month(9).date(1).endOf('quarter')],
		},
		locale: {
			format: 'DD.MM.YY',
			applyLabel: 'Bestätigen',
			cancelLabel: 'Abbrechen',
			customRangeLabel: 'Custom',
			monthNames: [
				"Januar",
				"Februar",
				"März",
				"April",
				"Mai",
				"Juni",
				"Juli",
				"August",
				"September",
				"Oktober",
				"November",
				"Dezember"
			],
			firstDay: 1
		}
	}, function(start, end, label) {
		this.element.closest('.form-group').addClass('filled');
		this.element.val(`${start.format('DD.MM.YY')}-${end.format('DD.MM.YY')}`);
		this.element.trigger("change");
	}).on('show.daterangepicker', function(ev, picker) {
		picker.element.closest('.form-group').addClass('focused');
		picker.container.addClass('show');
	}).on('hide.daterangepicker', function(ev, picker) {
		picker.element.closest('.form-group').removeClass('focused');
		picker.container.removeClass('show');
	});
}

document.querySelectorAll('input[name="kosten"]').forEach((input) => {
	input.addEventListener('change', function(event) {
		let value = event.target.value;
		input.value = value + "€";
	})
})

function showPopup() {
	return confirm("Are you sure you want to delete?");
}

document.querySelectorAll('.btn[data-delete]').forEach((button) => {
	button.addEventListener("click", function(event) {
		event.preventDefault();
		if (showPopup()) {
			// User clicked "Yes"
			console.log("Confirmed delete");
			// Proceed with your action, e.g. form.submit() or fetch()
			// You could also manually trigger the delete request here
		} else {
			// User clicked "No"
			console.log("Canceled delete");
		}
	})
})

const lang = $('html').attr('lang').slice(0, 2).toLowerCase();
function initSelect() {
	$('.js-select').select2({
		language: lang,
		width: "100%",
		dropdownPosition: "below",
		minimumResultsForSearch: -1
	})
		.on("select2:open", function (e) {
			const $parent = e.target.closest('.form-group');
			$($parent).addClass('filled');
		})
		.on("select2:close", function (e) {
			const $parent = $(e.target).closest('.form-group');
			const value = e.target.value;
			const isPlaceholder = $(e.target).attr('data-placeholder') ? true : false;
			if (value === "" && !isPlaceholder) {
				$parent.removeClass('filled');
			}
		})
		.on("select2:select", function (e) {
			const data = e.params.data;
			const $parent = $(e.target).closest('.form-group');
			if (data) {
				$parent.removeClass('has-error');
			} else {
				$parent.addClass('has-error');
			}
			// console.log(data);
		});

	// $( '.js-select-sm' ).select2({
	// 	language: 'ru',
	// 	width: '100%',
	// 	minimumResultsForSearch: -1,
	// 	containerCssClass: 'select-sm',
	// 	dropdownCssClass: 'select-sm-dropdown'
	// });
}

$( document ).ready( function() {

	/* - - - - - - - - - - - - - -       init inputmask       - - - - - - - - - - - - - - - */
	// $( '[type="tel"]' ).inputmask( '+38 (999) 999 99 99' );

	/* - - - - - - - - - - - - - -       input validate       - - - - - - - - - - - - - - - */
	function setInput() {
		$('input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea, select').each(function () {
			const $this = $(this);
			const $parent = $this.closest('.form-group');
			const isPlaceholder = $this.attr("placeholder") ? true : false;
			const isDataPlaceholder = $this.attr("data-placeholder") ? true : false;
			const isAutofill = $this[0].matches(':autofill') === true ? true : false;
			if ($this.val() !== '' || isPlaceholder || isDataPlaceholder || isAutofill) {
				$parent.addClass('filled');
			}
		});
	}
	setInput();
	setTimeout(setInput, 600);
	$(document).on('focus', 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea', function () {
		const $parent = $(this).closest('.form-group');
		$parent.addClass('filled');
	});
	$(document).on('blur', 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea', function () {
		$('input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea').each(function () {
			const $this = $(this);
			const $parent = $this.closest('.form-group');
			const isPlaceholder = $this.attr('placeholder') ? true : false;
			if ($this.val() === '' && !$this.is(':focus') && !isPlaceholder) {
				$parent.removeClass('filled');
			}
		});
	});
	$(document).on('input', 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"])[data-required], textarea[data-required]', function () {
		formValidate($(this));
		$(this).closest('.form-content').removeClass('has-error');
	});

	$(document).on('input', '[type="checkbox"], [type="radio"]', function () {
		const $this = $(this);
		if ($this.attr('data-required') !== undefined) {
			const $form = $this.closest('form');
			if ($this.closest('.form-checkbox')) {
				// $this.closest('.form-checkbox').removeClass( 'has-success', 'has-error' );
				const checkboxList = $form.find(`[name="${$this.attr('name')}"][data-required]`);
				let isCheck = false;
				checkboxList.each((i, item) => {
					if ($(item).prop('checked')) {
						isCheck = true;
					}
				});
				let parentCheckboxValidate = $this.closest('.checkbox-column') && checkboxList.length === 1 ? $this.closest('.checkbox') : $this.closest('.form-checkbox');
				if (isCheck) {
					parentCheckboxValidate.removeClass('has-error');
					parentCheckboxValidate.addClass('has-success');
				} else {
					parentCheckboxValidate.removeClass('has-success');
					parentCheckboxValidate.addClass('has-error');
				}
			}
		}
	});

	/* - - - - - - - - - - - - - -       init select2       - - - - - - - - - - - - - - - */
	initSelect();
	// setTimeout(initSelect, 10);

	/* - - - - - - - - - - - - - -       init daterangepicker       - - - - - - - - - - - - - - - */
	if ($('.js-date-range').length) {
		$('.js-date-range').each(function () {
			initDaterangepicker($(this))
		});
	}

	// function closeDaterangepicker() {
	// 	$('.js-date-range').closest('.form-group').removeClass('focused');
	// }
	//
	// if ($('.js-date-range').length) {
	// 	let ww = $(window).innerWidth();
	// 	$(window).on('resize', () => {
	// 		if ($(window).innerWidth() !== ww) {
	// 			ww = $(window).innerWidth();
	// 			closeDaterangepicker();
	// 		}
	// 	});
	// }

	/* - - - - - - - - - - - - - -       toggle field password       - - - - - - - - - - - - - - - */
	$('.js-toggle-view').on('click', function() {
		const $this = $(this);
		const $parent = $this.closest('.form-group');
		if (!$this.hasClass('active')) {
			$this.addClass('active');
			$parent.find('input').attr('type', 'text');
		} else {
			$this.removeClass('active');
			$parent.find('input').attr('type', 'password');
		}
	});

	/* - - - - - - - - - - - - - -       toggle filter       - - - - - - - - - - - - - - - */
	$('.js-filter-toggle').on('click', function() {
		$('.filter-list').toggleClass('show');
	});
	$(document).on('click', function(e) {
		const isOpenFilter = $(e.target).closest('.filter-list').length;
		const isOpenSelect = $(e.target).closest('.select2-dropdown').length;
		const isOpenDatepicker = $(e.target).closest('.daterangepicker').length;
		if ($(e.target).closest('.filter-toggle').length || isOpenFilter || isOpenSelect || isOpenDatepicker) {
			return;
		}
		$('.filter-list').removeClass('show');
	});

	if (typeof chartsOptions !== 'undefined' && chartsOptions.length) {
		chartsOptions.forEach(chart => {
			const chartId = chart.id;
			const chartDom = document.getElementById(chartId);
			const chartOptions = chart.options;
			if (chartDom) {
				const echartInit = echarts.init(chartDom, null, {
					renderer: 'svg',
					useDirtyRect: false,
				});

				if (chartOptions && typeof chartOptions === 'object') {
					// echartInit.setOption(chartOptions);

					if (chartOptions.series[0].type === 'bar') {
						changeAlignYAxis(chartDom, chartOptions)
					} else {
						echartInit.setOption(chartOptions);
					}
				}
				window.addEventListener('resize', echartInit.resize);
			}
		});
	}
});
